export default "__VITE_ASSET__a3eb9e26__"